import React from 'react';
import { IconLink, IconPlay } from '../icons';
import MenuSelect from './MenuSelect';
import { plural, sortOptions } from './util';
import './search.css';

// Above the Shows column while a Set Search is applied: the count, the sort
// menu (only meta.features.sorts), "Play the Matches", and share.
// `note` is meta.notes[0] ("Shows with a known setlist..." or, for bands
// matched from tape titles, "Matched from tape track titles.").
// Optional (additive): `mode` - in closest mode results are always ranked by
// score, so the sort menu is replaced by that line.
// Optional (additive): `fillNote` - a second note line for bands that mix
// setlist shows with shows matched from tape titles, when the search leaves
// those out (song order, slots, sandwiches, NOT).
export default function FindResultsHeader({ total, sort, sorts, onSort, onPlayMatches, onShare, loading, note, mode, fillNote }) {
  const opts = sortOptions(sorts);
  const count = typeof total === 'number' ? total : null;
  return (
    <div className="ss-rh">
      <div className="ss-rh-top">
        <span className="ss-rh-count" aria-live="polite">
          {count == null ? (loading ? 'Searching...' : '') : count === 0 ? 'No shows' : plural(count, 'show')}
          {loading && count != null && <span className="spinner ss-spin" aria-hidden="true" />}
        </span>
        {mode === 'closest' ? (
          <span className="ss-rh-sortnote">Closest match first</span>
        ) : (
          opts.length > 1 && <MenuSelect label="Sort" value={sort || 'date'} options={opts} onChange={onSort} className="ss-rh-sort" />
        )}
      </div>
      <div className="ss-rh-actions">
        <button type="button" className="btn-pill ss-play" onClick={onPlayMatches} disabled={!count || !onPlayMatches}>
          <IconPlay size={13} />
          <span>Play the Matches</span>
        </button>
        {onShare && (
          <button type="button" className="icon-btn ss-mini" onClick={onShare} disabled={!count && !loading} title="Copy Search Link" aria-label="Copy Search Link">
            <IconLink size={15} />
          </button>
        )}
      </div>
      {note && <div className="ss-rh-note">{note}</div>}
      {fillNote && <div className="ss-rh-note">{fillNote}</div>}
    </div>
  );
}
